export const EnterpriseBenefitStringIds: Record<string, string[]> = {
    leftPart: [
        'CLIENT_UNLIMITED_ROBOTS_AND_TENANTS',
        'CLIENT_ACCESS_TO_ADDITIONAL_UIPATH_SERVICES',
        'CLIENT_LARGE_DATA_STORAGE_AND_ENHANCED_DOCUMENT_UNDERSTANDING',
    ],
    rightPart: [ 'CLIENT_UNLIMITED_LICENSE_SUPPORT', 'CLIENT_IN_TIME_SUPPORT', 'CLIENT_GUARANTEED_UPTIME_SLA' ],
};
